<template>
  <div class="con-wrap">
    <el-row>
      <el-col :span="13" class="vehicle-state">
        <p class="box-title" style="height: 20px">{{ stateData.plateNum }}</p>
        <div class="state-con">
          <p class="con-title">
            <span style="margin-left: 10px">刷新时间:</span>
            <span>{{ stateData.refreshTime }}</span>
          </p>
          <el-row :gutter="20">
            <el-col :span="14" style="text-align: center">
              <img :src="stateData.version == 2
                  ? require('../../../../assets/images/vehicle-info-2.png')
                  : require('../../../../assets/images/vehicle-info.png')
                " alt />
            </el-col>
            <el-col :span="10" style="margin-top: 20px">
              <p class="line">
                <span class="ri">车辆状态:</span>
                <span class="lf">
                  {{ $judgeEmpty(stateData.vehicleStatus) }}
                </span>
              </p>
              <p class="line">
                <span class="ri">发电状态:</span>
                <span class="lf">
                  {{ $judgeEmpty(stateData.dynamoStatus) }}
                </span>
              </p>
              <p class="line" v-if="stateData.version != 2">
                <span class="ri">抽油状态:</span>
                <span class="lf">
                  {{ $judgeEmpty(stateData.oilPumpingStatus) }}
                </span>
              </p>
              <!-- <p class="line">
                <span class="ri">当前档位:</span>
                <span class="lf">{{ $judgeEmpty(stateData.gear) }}档</span>
              </p> -->
              <p class="line">
                <span class="ri">剩余油量:</span>
                <span class="lf">{{ stateData.oilVolume }}</span>
              </p>
              <p class="line">
                <span class="ri" v-if="stateData.version == 2">增程器剩余保养里程:</span>
                <span class="ri" v-else>剩余保养里程:</span>
                <span class="lf">
                  {{ stateData.maintainMileage }}
                </span>
              </p>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="11" class="vehicle-location">
        <p class="box-title">
          <span>车辆定位</span>
          <span class="open" @click="openMap">
            <i class="iconfont icon-open"></i>展开
          </span>
        </p>
        <div class="location-wrap">
          <div id="map-box"></div>
          <div class="info-con">
            <p>
              <span>经度:</span>
              <span>{{ information.lng }}</span>
            </p>
            <p>
              <span>纬度:</span>
              <span>{{ information.lat }}</span>
            </p>
            <p>
              <span>详细地址:</span>
              <span>{{ information.address }}</span>
            </p>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="vehicle-monitor">
      <p class="box-title" style="padding-top: 10px">数据监控</p>
      <div style="height: calc(100% - 41px); overflow-y: auto">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="实时数据" name="second">
            <el-row class="vehicleInfoTable">
              <el-col class="list-header">发电机发电状态</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.state)
              }}</el-col>

              <el-col class="list-header">发电量（KW·H）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.capacity)
              }}</el-col>

              <el-col class="list-header">总正向有功功率（W）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.forwardPower)
              }}</el-col>

              <el-col class="list-header">发电时长（分钟）</el-col>
              <el-col class="list-td" v-if="powerData.duration < 0">-</el-col>
              <el-col class="list-td" v-else>{{
                $judgeEmpty(powerData.duration)
              }}</el-col>

              <el-col class="list-header">发电平均油耗（L/H）</el-col>
              <el-col class="list-td">{{
                handle25(powerData.generatorFuleConsumption)
              }}</el-col>

              <el-col class="list-header">剩余油量（L）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.adFuel)
              }}</el-col>

              <el-col class="list-header">频率（HZ）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.frequency)
              }}</el-col>

              <el-col class="list-header">发电机温度（℃）</el-col>
              <el-col class="list-td" v-if="stateData.vehicleStatus == '待命'">-</el-col>
              <el-col class="list-td" v-else :class="[
                stateData.version == 2 && powerData.ptoTemperature > 138
                  ? 'redTemperature'
                  : '',
              ]">{{ $judgeEmpty(powerData.ptoTemperature) }}</el-col>

              <el-col class="list-header">电表总发电量（KW·H）</el-col>
              <el-col class="list-td">{{ $toFixed2(powerData.energy) }}</el-col>

              <el-col class="list-header">保养后发电量（KW·H）</el-col>
              <el-col :title="powerChange(powerData.curCapacity)" class="list-td overflow-hidden"
                :class="classChange(stateData.maintainMileage)">{{ powerChange(powerData.curCapacity) }}</el-col>

              <el-col class="list-header">L1电压有效值（V）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.l1Voltage)
              }}</el-col>

              <el-col class="list-header">L1电流有效值（A）</el-col>
              <el-col class="list-td" :class="[
                stateData.version == 2 && powerData.l1Electricity > 65.3
                  ? 'redTemperature'
                  : '',
              ]">{{ $judgeEmpty(powerData.l1Electricity) }}</el-col>

              <el-col class="list-header">L2电压有效值（V）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.l2Voltage)
              }}</el-col>

              <el-col class="list-header">L2电流有效值（A）</el-col>
              <el-col class="list-td" :class="[
                stateData.version == 2 && powerData.l2Electricity > 65.3
                  ? 'redTemperature'
                  : '',
              ]">{{ $judgeEmpty(powerData.l2Electricity) }}</el-col>

              <el-col class="list-header">L3电压有效值（V）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.l3Voltage)
              }}</el-col>

              <el-col class="list-header">L3电流有效值（A）</el-col>
              <el-col class="list-td" :class="[
                stateData.version == 2 && powerData.l3Electricity > 65.3
                  ? 'redTemperature'
                  : '',
              ]">{{ $judgeEmpty(powerData.l3Electricity) }}</el-col>
              <el-col class="list-header" v-if="powerData.gearsError">发电档位错误</el-col>
              <el-col class="list-td" v-if="powerData.gearsError">{{
                judgePowerData(powerData.gearsError)
              }}</el-col>

              <el-col class="list-header" v-if="powerData.cluthError">发电中踩离合故障</el-col>
              <el-col class="list-td" v-if="powerData.cluthError">{{
                judgePowerData(powerData.cluthError)
              }}</el-col>

              <el-col class="list-header" v-if="powerData.diagnoseError">发电诊断错误</el-col>
              <el-col class="list-td" v-if="powerData.diagnoseError">{{
                judgePowerData(powerData.diagnoseError)
              }}</el-col>
              <el-col class="list-header">剩余发电时长（分钟）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.surplusDuration)
              }}</el-col>
              <template v-if="vehicleData.version == 2">
                <el-col class="list-header">逆变器负载有功功率瞬时值（kw）</el-col>
                <el-col class="list-td">{{
                  instPower(powerData.tgcuInstPower)
                }}</el-col>
                <el-col class="list-header">逆变器负载有功功率平均值（kw）</el-col>
                <el-col class="list-td">{{
                  instPower(powerData.tgcuAverPower)
                }}</el-col>
                <el-col class="list-header">排气散热舱的温度（℃）</el-col>
                <el-col class="list-td">{{
                  exhaustTemp(powerData.tgcuExhaustTemp)
                }}</el-col>
                <el-col class="list-header" v-if="powerData.overloadAlarm">发电机过载告警</el-col>
                <el-col class="list-td" v-if="powerData.overloadAlarm">{{
                  judgePowerData(powerData.overloadAlarm)
                }}</el-col>

                <el-col class="list-header" v-if="powerData.phaseAlarm">发电机缺相告警</el-col>
                <el-col class="list-td" v-if="powerData.phaseAlarm">{{
                  judgePowerData(powerData.phaseAlarm)
                }}</el-col>

                <el-col class="list-header" v-if="powerData.shortAlarm">发电机短路告警</el-col>
                <el-col class="list-td" v-if="powerData.shortAlarm">{{
                  judgePowerData(powerData.shortAlarm)
                }}</el-col>
                <el-col class="list-header" v-show="powerData.ptoHighttemperatureAlarm">发电机高温报警</el-col>
                <el-col class="list-td" v-show="powerData.ptoHighttemperatureAlarm">{{
                  judgePowerData(powerData.ptoHighttemperatureAlarm)
                }}</el-col>
                <el-col class="list-header" v-show="powerData.lowFuelAlarm">低油量告警</el-col>
                <el-col class="list-td" v-show="powerData.lowFuelAlarm">{{
                  judgePowerData(powerData.lowFuelAlarm)
                }}</el-col>

                <el-col class="list-header" v-show="handleCodeDC(powerData.dcFaultCode) != '-'">DC告警故障码</el-col>
                <el-col class="list-td" v-show="handleCodeDC(powerData.dcFaultCode) != '-'">{{
                  handleCodeDC(powerData.dcFaultCode) }}</el-col>
                <el-col class="list-header" v-show="handleCodeAC(powerData.acFaultCode) != '-'">AC告警故障码</el-col>
                <el-col class="list-td" v-show="handleCodeAC(powerData.acFaultCode) != '-'">{{
                  handleCodeAC(powerData.acFaultCode) }}</el-col>
                <el-col class="list-header" v-show="powerData.generationSelfCheck">发电自检告警</el-col>
                <el-col class="list-td" v-show="powerData.generationSelfCheck">{{
                  judgePowerData(powerData.generationSelfCheck) }}</el-col>
                <el-col class="list-header" v-show="powerData.inverterCommunication">逆变器通讯告警</el-col>
                <el-col class="list-td" v-show="powerData.inverterCommunication">{{
                  judgePowerData(powerData.inverterCommunication) }}</el-col>
                <el-col class="list-header" v-show="powerData.overVoltage">高压关闭异常</el-col>
                <el-col class="list-td" v-show="powerData.overVoltage">{{
                  judgePowerData(powerData.overVoltage)
                }}</el-col>
                <el-col class="list-header" v-show="powerData.exhaustChamberHigh">排气仓高温报警</el-col>
                <el-col class="list-td" v-show="powerData.exhaustChamberHigh">{{
                  judgePowerData(powerData.exhaustChamberHigh)
                }}</el-col>

                <el-col class="list-header" v-show="powerData.exhaustChamberLow">排气仓低温报警</el-col>
                <el-col class="list-td" v-show="powerData.exhaustChamberLow">{{
                  judgePowerData(powerData.exhaustChamberLow)
                }}</el-col>
                <el-col class="list-header" v-show="powerData.batterySocLow">电池SOC低告警</el-col>
                <el-col class="list-td" v-show="powerData.batterySocLow">{{
                  judgePowerData(powerData.batterySocLow)
                }}</el-col>
                <el-col class="list-header" v-show="powerData.stopSupply">停止供电告警</el-col>
                <el-col class="list-td" v-show="powerData.stopSupply">{{
                  judgePowerData(powerData.stopSupply)
                }}</el-col>
                <el-col class="list-header" v-show="powerData.rangeExtenderStop">增程器异常停机告警</el-col>
                <el-col class="list-td" v-show="powerData.rangeExtenderStop">{{
                  judgePowerData(powerData.rangeExtenderStop)
                }}</el-col>
                <el-col class="list-header">排气扇档位</el-col>
                <el-col class="list-td">{{
                  exhaustFanData(powerData.exhaustFan)
                }}</el-col>
              </template>
              <el-col class="list-header">距离下次保养剩余发电量（KW·H）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.maintenanceRemainingCapacity)
              }}</el-col>

              <el-col class="list-header">车辆总发电量（KW·H）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(powerData.totalElectricity)
              }}</el-col>
            </el-row>

            <div style="height: 6px"></div>

            <el-row class="vehicleInfoTable">
              <el-col class="list-header">发动机转速（RPM）</el-col>
              <el-col class="list-td">{{
                engineHandle(vehicleData.emsEngineSpeed)
              }}</el-col>
              <el-col class="list-header">发动机冷却液温度（℃）</el-col>
              <el-col class="list-td" :class="[
                vehicleData.version == 2 &&
                  vehicleData.emsEngineCoolanTemperature > 114 &&
                  handle207(vehicleData.emsEngineCoolanTemperature) != '-'
                  ? 'redTemperature'
                  : '',
              ]">
                {{ handle207(vehicleData.emsEngineCoolanTemperature) }}</el-col>
              <el-col class="list-header">行驶平均油耗（L/100km）</el-col>
              <el-col class="list-td">{{
                handle25(vehicleData.emsFuleConsumption)
              }}</el-col>
              <el-col class="list-header">车速（km/h）</el-col>
              <el-col class="list-td">{{
                speedHandle(vehicleData.absVehicleSpeed)
              }}</el-col>
              <el-col class="list-header">行驶里程（km）</el-col>
              <el-col class="list-td">{{
                invalidData(vehicleData.totalMileage)
              }}</el-col>
              <el-col class="list-header">保养后行驶里程（km）</el-col>
              <el-col class="list-td" :class="classChange(stateData.maintainMileage)">{{
                invalidData(vehicleData.curMileage)
                }}</el-col>
              <template v-if="vehicleData.version == 2">
                <el-col class="list-header">电池SOC（%）</el-col>
                <el-col class="list-td">{{
                  socinvalidData(vehicleData.vcuBattSoc)
                }}</el-col>
                <el-col class="list-header">电池总电压（V）</el-col>
                <el-col class="list-td">{{
                  vdcinvalidData(vehicleData.bmsBattU)
                }}</el-col>
                <el-col class="list-header">电池充/放电电流（A）</el-col>
                <el-col class="list-td">{{
                  ainvalidData(vehicleData.bmsBattCrrt)
                }}</el-col>
                <el-col class="list-header">电池充/放电功率（kw）</el-col>
                <el-col class="list-td">{{
                  ainvalidData(vehicleData.bmsBattPower)
                }}</el-col>
                <el-col class="list-header">电池充/放电状态</el-col>
                <el-col class="list-td" v-if="vehicleData.vehChrgSts == 1">停车充电</el-col>
                <el-col class="list-td" v-else-if="vehicleData.vehChrgSts == 2">行驶充电</el-col>
                <el-col class="list-td" v-else-if="vehicleData.vehChrgSts == 3">未充电</el-col>
                <el-col class="list-td" v-else-if="vehicleData.vehChrgSts == 4">充电完成</el-col>
                <el-col class="list-td" v-else>-</el-col>

                <el-col class="list-header">发电机输出电压（V）</el-col>
                <el-col class="list-td">{{
                  vdcinvalidData(vehicleData.dcMainWireVolt)
                }}</el-col>

                <el-col class="list-header">发电机输出电流（A）</el-col>
                <el-col class="list-td">{{
                  ainvalidData(vehicleData.dcMainWireCurr)
                }}</el-col>
                <el-col class="list-header">发电机输出功率（kw）</el-col>
                <el-col class="list-td">{{
                  ainvalidData(vehicleData.dcMainWirePower)
                }}</el-col>
              </template>

              <el-col class="list-header" v-if="vehicleData.emsBatteryVoltageError">电源电压（V）</el-col>
              <el-col class="list-td" v-if="vehicleData.emsBatteryVoltageError">{{
                handle255(vehicleData.emsBatteryVoltage)
                }}</el-col>
              <el-col class="list-header" v-if="vehicleData.emsBatteryVoltageError">电源电压故障检测</el-col>
              <el-col class="list-td" v-if="vehicleData.emsBatteryVoltageError">{{
                judgeData(vehicleData.emsBatteryVoltageError)
                }}</el-col>
              <el-col class="list-header" v-if="vehicleData.emsIntakeAirTempSensorError">进气温度传感器故障</el-col>
              <el-col class="list-td" v-if="vehicleData.emsIntakeAirTempSensorError">{{
                judgeData(vehicleData.emsIntakeAirTempSensorError)
              }}</el-col>
              <el-col class="list-header" v-if="vehicleData.emsAccpedelError">加速踏板故障</el-col>
              <el-col class="list-td" v-if="vehicleData.emsAccpedelError">{{
                judgeData(vehicleData.emsAccpedelError)
              }}</el-col>
              <el-col class="list-header" v-if="vehicleData.emsThrottleValuePositionError">节气门位置故障</el-col>
              <el-col class="list-td" v-if="vehicleData.emsThrottleValuePositionError">{{
                judgeData(vehicleData.emsThrottleValuePositionError)
              }}</el-col>
              <el-col class="list-header" v-if="vehicleData.emsEngineSpeedError">发动机转速故障</el-col>
              <el-col class="list-td" v-if="vehicleData.emsEngineSpeedError">{{
                judgeData(vehicleData.emsEngineSpeedError)
              }}</el-col>
              <el-col class="list-header" v-if="vehicleData.emsCoolanTemperatureError">发动机冷却液温度故障</el-col>
              <el-col class="list-td" v-if="vehicleData.emsCoolanTemperatureError">{{
                judgeData(vehicleData.emsCoolanTemperatureError) }}</el-col>
              <el-col class="list-header" v-if="vehicleData.emsMil">发动机故障指示灯</el-col>
              <el-col class="list-td" v-if="vehicleData.emsMil">{{
                judgeData(vehicleData.emsMil)
              }}</el-col>
              <el-col class="list-header">发电折算总里程（km）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(vehicleData.powerGenerationMileage)
              }}</el-col>
              <el-col class="list-header" v-if="vehicleData.version == 1">总里程（km）</el-col>
              <el-col class="list-td" v-if="vehicleData.version == 1">{{
                $judgeEmpty(vehicleData.electricityTotalMileage)
              }}</el-col>
              <el-col class="list-header">距离下次保养剩余使用里程（km）</el-col>
              <el-col class="list-td">{{
                $judgeEmpty(vehicleData.remainingMileage)
              }}</el-col>
              <el-col class="list-header" v-if="vehicleData.version == 1">保养后使用里程（km）</el-col>
              <el-col v-if="vehicleData.version == 1" class="list-td" :class="classChange(stateData.maintainMileage)">{{
                invalidData(vehicleData.useMileage) }}</el-col>
              <template v-if="vehicleData.version == 2">
                <!-- <el-col class="list-header">发电标记</el-col>
                <el-col class="list-td">{{
                  powerMarkData(vehicleData.generatingMark)
                }}</el-col> -->
                <el-col class="list-header">动力电池故障</el-col>
                <el-col class="list-td">{{
                  judgePowerData(vehicleData.powerBatteryFailure)
                }}</el-col>
                <el-col class="list-header">发电机控制器温度（℃）</el-col>
                <el-col class="list-td">{{
                  igbttemp(vehicleData.igbttemp)
                }}</el-col>
                <el-col class="list-header">发电机控制器输出功率（kw）</el-col>
                <el-col class="list-td">{{
                  outputGenerator(vehicleData.outputGenerator)
                }}</el-col>
              </template>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="今日告警列表" name="third">
            <el-table ref="multipleTable" :data="alarmTableData" tooltip-effect="dark" style="width: 100%" size="mini"
              stripe height="350">
              <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
              <el-table-column prop="warnName" label="告警名称"></el-table-column>
              <el-table-column prop="startTime" label="开始时间"></el-table-column>
              <el-table-column prop="endTime" label="结束时间"></el-table-column>
              <el-table-column prop="warnType" label="告警状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.warnType == 2" class="btn-green">告警解除</span>
                  <span v-else-if="scope.row.warnType == 1" class="btn-red">告警中</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="车辆定位" :visible.sync="mapVisible" class="map-dialog">
      <div id="open-map"></div>
      <div class="fresh">
        <span class="fresh-time">{{ freshTime }}</span>
        <el-button type="primary" @click="refreshOpenMap">刷新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
export default {
  name: "RealtimeData",
  props: {
    vin: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentTab: "second",
      stateData: {},
      map: null,
      marker: "",
      position: [],
      geocoder: {},
      information: {
        lat: "",
        lng: "",
        address: "",
      },
      mapVisible: false,
      freshTime: "2020-05-20 05:20:00",
      opnMap: null,
      openMarker: "",
      content: [],
      infoWindow: "",
      openFlag: false,
      activeName: "second",
      vehicleData: {},
      powerData: {},
      alarmTableData: [],
      timer: null,
      scale: null,
      //防止每次数据改变重置定位地图
      onceFlag: true,
      clickFlag: false,
    };
  },
  updated() {
    if (this.onceFlag) {
      this.opnMap = new AMap.Map("open-map", {
        center: [116.397428, 39.90923],
        resizeEnable: true,
        zoom: 10,
      });

      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.opnMap.addControl(this.scale);
      });
    }
    if (this.clickFlag) {
      this.onceFlag = false;
    }
  },
  created() {
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    this.getState();
    this.getLocation();
    this.getVehicleData();
    this.getPowerData();
  },
  mounted() {
    this.init();
  },
  methods: {
    classChange(value) {
      let val = parseInt(value);
      if (val > 1000 && val <= 1500) {
        return "warningBg warning1";
      } else if (val <= 1000 && val > 500) {
        return "warningBg warning2";
      } else if (val <= 500 && val > 200) {
        return "warningBg warning3";
      } else if (val <= 200 && val > 0) {
        return "warningBg warning4";
      } else if (val === "") {
        return val;
      } else if (val <= 0) {
        return "warningBg warning5";
      }
    },
    setTimer() {
      let _this = this;
      if (_this.timer == null) {
        _this.timer = setInterval(() => {
          // if (_this.currentTab == "first") {
          //   _this.getVehicleData()
          // } else
          if (_this.currentTab == "second") {
            _this.getVehicleData();
            _this.getPowerData();
          } else if (_this.currentTab == "third") {
            _this.getAlarmData();
          }
          this.getState();
          this.getLocation();
          //十秒执行一次
        }, 10000);
      }
    },
    async getState() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/status?vin=" + _this.vin
      );
      if (res.code == 1) {
        _this.stateData = res.data;
        sessionStorage.setItem("version", _this.stateData.version);
        _this.stateData.dynamoStatus =
          _this.stateData.dynamoStatus == 0 ? "未发电" : "发电中";
        _this.stateData.oilPumpingStatus =
          _this.stateData.oilPumpingStatus == 0
            ? "未抽油"
            : _this.stateData.oilPumpingStatus == 1
              ? "抽油中"
              : "--";
        if (
          _this.stateData.oilVolume === "" ||
          _this.stateData.oilVolume > 300
        ) {
          _this.stateData.oilVolume = "-";
        } else {
          _this.stateData.oilVolume = _this.stateData.oilVolume + " L";
        }
        if (_this.stateData.maintainMileage == "") {
          _this.stateData.maintainMileage = "-";
        } else {
          _this.stateData.maintainMileage =
            _this.stateData.maintainMileage + " KM";
        }
        if (_this.stateData.vehicleStatus != "") {
          _this.stateData.vehicleStatus =
            _this.stateData.vehicleStatus == 1 ? "待命" : "在线";
        }
        _this.stateData.gear =
          _this.stateData.gear == 0 ? "空" : _this.stateData.gear;
        _this.stateData.plateNum == "" ? "--" : _this.stateData.plateNum;
        if (!_this.stateData.plateNum) {
          _this.stateData.plateNum = "--";
        }
      } else {
        // _this.$message.warning(res.msg)
      }
    },
    init() {
      this.map = new AMap.Map("map-box", {
        center: [116.397428, 39.90923],
        resizeEnable: true,
        zoom: 10,
      });
      AMap.plugin(["AMap.Geocoder"], () => {
        this.geocoder = new AMap.Geocoder({
          city: "全国", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        });
      });
    },
    async getLocation() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/location?vin=" + _this.vin
      );
      if (res.code == 1) {
        _this.position = [res.data.longitude, res.data.latitude];
        _this.information.lat = res.data.latitude;
        _this.information.lng = res.data.longitude;
        //清理覆盖物
        if (_this.marker) {
          _this.map.remove(_this.marker);
        }
        _this.marker = new AMap.Marker({
          position: _this.position,
        });
        _this.map.setCenter(_this.position);
        _this.map.add(_this.marker);
        if (res.data.longitude != 0) {
          _this.getAddr(_this.position);
        }
      } else {
        // _this.$message.warning(res.msg)
      }
    },
    getAddr(position) {
      // 确保 geocoder 已初始化
      if (!this.geocoder) {
        console.error("Geocoder 未初始化，请检查插件加载");
        return;
      }
      let _this = this;
      _this.geocoder.getAddress(position, function (status, result) {
        if (status === "complete" && result.regeocode) {
          _this.information.address = result.regeocode.formattedAddress;
        }
        //  else {
        //   _this.$message.warning("根据经纬度查询地址失败")
        // }
      });
    },
    //地图展开
    refreshOpenMap() {
      this.getLocation();
      this.openMap();
    },
    openMap() {
      this.freshTime = this.$nowDate();
      let _this = this;
      this.mapVisible = true;
      this.clickFlag = true;
      this.openMarker = new AMap.Marker({
        position: _this.position,
      });
      this.content = [];
      this.content.push(
        "<p><span style='margin-right:6px'>经度:</span>" +
        this.information.lng +
        "</p><p><span style='margin-right:6px'>纬度:</span>" +
        this.information.lat +
        "</p><p><span style='margin-right:6px'>详细地址:</span>" +
        this.information.address +
        "</p>"
      );
      this.infoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: _this.createInfoWindow(_this.content),
        offset: new AMap.Pixel(16, -45),
      });
      this.$nextTick(() => {
        _this.opnMap.clearMap();
        _this.opnMap.setCenter(_this.position);
        _this.opnMap.add(_this.openMarker);
        _this.infoWindow.open(_this.opnMap, _this.openMarker.getPosition());
        AMap.event.addListener(_this.openMarker, "click", function () {
          if (_this.openFlag) {
            _this.infoWindow.open(_this.opnMap, _this.openMarker.getPosition());
            _this.openFlag = false;
          } else {
            _this.opnMap.clearInfoWindow();
            _this.openFlag = true;
          }
        });
      });
    },
    createInfoWindow() {
      let info = document.createElement("div");
      info.className = "realtimeLocation";

      //可以通过下面的方式修改自定义窗体的宽高
      //info.style.width = "400px";

      // 定义中部内容
      let middle = document.createElement("div");
      middle.className = "info-middle";
      middle.style.backgroundColor = "white";
      middle.innerHTML = this.content;
      info.appendChild(middle);

      let bottom = document.createElement("div");
      bottom.className = "info-bottom";
      bottom.style.position = "relative";
      bottom.style.top = "0px";
      bottom.style.margin = "0 auto";
      let sharp = document.createElement("img");
      sharp.src = "https://webapi.amap.com/images/sharp.png";
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },
    handleClick(tab) {
      this.currentTab = tab.name;
      // if (tab.name == "first") {
      //   this.getVehicleData()
      // } else
      if (tab.name == "second") {
        this.getVehicleData();
        this.getPowerData();
      } else if (tab.name == "third") {
        this.getAlarmData();
      }
    },
    async getVehicleData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/vehicle/real?vin=" + _this.vin
      );
      if (res.code == 1) {
        _this.vehicleData = res.data;
        if (_this.vehicleData.totalMileage == 4294967295) {
          _this.vehicleData.totalMileage = "-";
        }
      } else {
        // _this.$message.warning(res.msg)
      }
    },
    async getPowerData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/dynamo/real?vin=" + _this.vin
      );
      if (res.code == 1) {
        _this.powerData = res.data;
        _this.powerData.state =
          _this.powerData.state == 0 ? "未发电" : "发电中";
        _this.powerData.generatorFuleConsumption =
          _this.powerData.generatorFuleConsumption == "255"
            ? "-"
            : _this.powerData.generatorFuleConsumption;
        _this.powerData.adFuel =
          _this.powerData.adFuel > 300 ? "-" : _this.powerData.adFuel;
        //总正向有功功率
        _this.powerData.forwardPower =
          _this.powerData.forwardPower == "65535"
            ? "-"
            : _this.powerData.forwardPower;
        // 发电机温度高于138℃变红
        // _this.powerData.netSignalStrength =
        //   _this.powerData.netSignalStrength == "255"
        //     ? "-"
        //     : _this.powerData.netSignalStrength
        // if (_this.powerData.stopGeneratingEle == 0) {
        //   _this.powerData.stopGeneratingEle = "无"
        // } else if (_this.powerData.stopGeneratingEle == 1) {
        //   _this.powerData.stopGeneratingEle = "平台停止发电"
        // } else if (_this.powerData.stopGeneratingEle == 2) {
        //   _this.powerData.stopGeneratingEle = "告警停止发电"
        // }
        // if (_this.powerData.oilPumpingState == 0) {
        //   _this.powerData.oilPumpingState = "未抽油"
        // } else if (_this.powerData.emsMil == 1) {
        //   _this.powerData.oilPumpingState = "抽油中"
        // } else {
        //   _this.powerData.oilPumpingState = "-"
        // }
      } else {
        // _this.$message.warning(res.msg)
      }
    },
    async getAlarmData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/dynamo/warning/day?vin=" + _this.vin
      );
      if (res.code == 1) {
        if (!res.data) {
          return;
        }
        _this.alarmTableData = res.data;
      } else {
        // _this.$message.warning(res.msg)
      }
    },
    handleCodeDC(data) {
      if (data === "" || data == null || data == "无") {
        return "-";
      } else if (data == "01") {
        return "电池过压";
      } else if (data == "02") {
        return "电池欠压";
      } else if (data == "03") {
        return "母线欠压";
      } else if (data == "05") {
        return "电池过流";
      } else if (data == "13") {
        return "拍停";
      } else if (data == "14") {
        return "过热";
      } else if (data == "16") {
        return "IGBT 模块保护";
      } else if (data == "17") {
        return "遥停";
      } else if (data == "18") {
        return "系统故障";
      } else if (data == "19") {
        return "硬件过压";
      } else if (data == "21") {
        return "互锁停机";
      }
    },
    handleCodeAC(data) {
      if (data === "" || data == null || data == "无") {
        return "-";
      } else if (data == "02") {
        return "母线欠压";
      } else if (data == "03") {
        return "A 相过压";
      } else if (data == "05") {
        return "B 相过压";
      } else if (data == "07") {
        return "C 相过压";
      } else if (data == "10") {
        return "A 相过流";
      } else if (data == "11") {
        return "B 相过流";
      } else if (data == "12") {
        return "C 相过流";
      } else if (data == "13") {
        return "拍停";
      } else if (data == "14") {
        return "过热";
      } else if (data == "16") {
        return "IGBT 模块保护";
      } else if (data == "18") {
        return "系统故障 ";
      } else if (data == "19") {
        return "硬件过压";
      } else if (data == "21") {
        return "互锁停机";
      }
    },
    judgeData(data) {
      if (data === "" || data == null) {
        return "-";
      } else {
        if (data == 0) {
          return "无故障";
        } else if (data == 1) {
          return "故障";
        }
      }
    },
    exhaustFanData(data) {
      if (data === "" || data == null) {
        return "-";
      } else if (data === 0) {
        return "关闭";
      } else if (data == 1) {
        return "关闭";
      } else if (data == 2) {
        return "1档";
      } else if (data == 3) {
        return "2档";
      } else if (data == 4) {
        return "3档";
      } else if (data == 5) {
        return "4档";
      } else if (data == 6) {
        return "5档";
      } else if (data == 7) {
        return "6档";
      } else if (data == 8) {
        return "7档";
      } else if (data == 9) {
        return "8档";
      }
    },
    powerMarkData(data) {
      if (data === "" || data == null) {
        return "-";
      } else if (data === 0) {
        return "未发电";
      } else if (data == 1) {
        return "手动启动";
      } else if (data == 2) {
        return "手动关闭";
      } else if (data == 3) {
        return "遥控启动";
      } else if (data == 4) {
        return "遥控关闭";
      }
    },
    instPower(data) {
      if (data === "" || data == null || data == 0) {
        return "-";
      } else {
        if (data == "6553.5") {
          return "-";
        } else {
          return data;
        }
      }
    },
    exhaustTemp(data) {
      if (data === "" || data == null || data == 0) {
        return "-";
      } else {
        if (data > 1000) {
          return "-";
        } else {
          return data;
        }
      }
    },
    igbttemp(data) {
      if (data === "" || data == null || data == 0) {
        return "-";
      } else {
        if (data >= 215) {
          return "-";
        } else {
          return data;
        }
      }
    },
    outputGenerator(data) {
      if (data === "" || data == null || data == 0) {
        return "-";
      } else {
        if (data >= 553.05) {
          return "-";
        } else {
          return data;
        }
      }
    },
    judgePowerData(data) {
      if (data === "" || data == null) {
        return "-";
      } else {
        if (data == 0) {
          return "未告警";
        } else if (data == 1) {
          return "告警";
        }
      }
    },
    invalidData(data) {
      if (data === "" || data == null || data == 0) {
        return "-";
      } else {
        if (
          data == "4294967295" ||
          data == "5553.5" ||
          data == "6553.5" ||
          data == "255"
        ) {
          return "-";
        } else {
          return data;
        }
      }
    },
    socinvalidData(data) {
      if (data === "" || data == null || data == 0) {
        return "-";
      } else {
        if (data == "255") {
          return "-";
        } else {
          return data;
        }
      }
    },
    vdcinvalidData(data) {
      if (data === "" || data == null || data == 0) {
        return "-";
      } else {
        if (data == "6553.5") {
          return "-";
        } else {
          return data;
        }
      }
    },
    ainvalidData(data) {
      if (data === "" || data == null || data == 0) {
        return "-";
      } else {
        if (data == "5553.5") {
          return "-";
        } else {
          return data;
        }
      }
    },
    speedHandle(val) {
      if (val == "" || val == null || val > 360 || val == 0) {
        return "-";
      } else {
        return val;
      }
    },
    handle255(val) {
      if (val == "" || val == null || val == 255) {
        return "-";
      } else {
        return val;
      }
    },
    handle25(val) {
      if (val == "" || val == null || val == 25.5 || val < 0 || val == 0) {
        return "-";
      } else {
        return val;
      }
    },
    handle207(val) {
      if (val == "" || val == null || val == 207 || val == 0) {
        return "-";
      } else {
        return val;
      }
    },
    engineHandle(val) {
      if (val == "" || val == null || val > 16383.5 || val == 0) {
        return "-";
      } else {
        return val;
      }
    },
    emsMilHandle(val) {
      if (val == 0) {
        return "OFF";
      } else if (val == 1) {
        return "ON";
      } else if (val == 2) {
        return "Reserved";
      } else if (val == 3) {
        return "Error";
      }
    },
    powerChange(val) {
      if (val == "" || val == null) {
        return "-";
      } else {
        let data = "  (约等于行驶" + (val * 7).toFixed(2) + "km)";
        return val.toFixed(2) + data;
      }
    },
  },
  destroyed: function () {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  height: 100%;
  margin: 0;
  background-color: #fff;
}

.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}

.vehicle-state {
  height: 330px;
  background: #f8f8f8;
}

.state-con {
  height: 300px;
  margin-right: 20px;
  background: #fff;
}

.vehicle-location {
  height: 330px;
  background: #fff;
}

.vehicle-monitor {
  width: 100%;
  height: calc(100% - 330px);
  background: #fff;
}

.con-title {
  padding: 20px;
  font-size: 16px;
  color: #343434;
}

.line {
  line-height: 28px;
  color: #343434;
  font-size: 14px;
}

.line .lf {
  display: inline-block;
  text-align: left;
}

.line .ri {
  width: 130px;
  display: inline-block;
  margin-right: 10px;
  text-align: right;
}

.location-wrap {
  height: 300px;
  position: relative;
}

#map-box {
  height: 300px;
}

.info-con {
  width: 100%;
  padding: 10px 20px;
  color: #fff;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 160;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.6);
}

.info-con p {
  line-height: 26px;
  font-size: 14px;
}

.info-con p span:first-child {
  margin-right: 10px;
}

.open {
  float: right;
  cursor: pointer;
  font-size: 14px;
}

.open:hover {
  color: #0094ff;
}

.open i {
  padding-right: 6px;
}

//地图展开
.fresh-time {
  display: inline-block;
  width: 170px;
  font-size: 16px;
}

.map-dialog /deep/ {
  .el-dialog {
    width: 1200px;
    height: 700px;
  }

  .el-dialog__body {
    height: calc(100% - 60px);
    padding: 10px;
  }
}

.fresh {
  width: 290px;
  height: 60px;
  line-height: 60px;
  border-radius: 6px;
  padding: 0 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  position: absolute;
  top: 60px;
  left: 20px;
}

#open-map {
  width: 100%;
  height: 100%;
}

.map-dialog /deep/ .info-middle {
  border: 1px solid #cbcbcb;
  border-radius: 6px;
  padding: 12px;
  color: #333;
}

.map-dialog /deep/ .info-bottom img {
  position: absolute;
  bottom: -22px;
  left: 144px;
}

//实时监控
.con-wrap /deep/ .el-tabs__nav {
  margin-left: 18px;
}

table,
table tr th,
table tr td {
  border: 1px solid #dfdfdf;
}

.vehicle-monitor /deep/ .el-tabs__content {
  padding: 0 20px;
}

.vehicle-monitor /deep/ .el-table--mini td {
  padding: 8px 0;
}

.vehicle-monitor /deep/ .el-table--mini th {
  padding: 8px 0;
}

.list-header {
  width: 30%;
  height: 29px;
  line-height: 29px;
  text-align: center;
  border: 1px solid #dfdfdf;
  font-weight: 600;
  background: #ddeffd;
}

.list-td {
  width: 20%;
  height: 29px;
  line-height: 29px;
  border: 1px solid #dfdfdf;
  padding-left: 12px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.redTemperature {
  color: #f53929;
}

.overflow-hidden:hover {
  cursor: pointer;
  text-overflow: clip;
}

//改变布局
.vehicleInfoTable {
  width: 90%;
  min-width: 766px;
  border-collapse: collapse;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
  display: inline-block;
  border: 1px solid #dfdfdf;

  .warningBg {
    color: #fff;
    padding: 2px;
    border-radius: 4px;
  }

  /* 文字颜色 */
  .warning1 {
    background-color: #e8d210;
  }

  .warning2 {
    background-color: #ffb505;
  }

  .warning3 {
    background-color: #ff7b05;
  }

  .warning4 {
    background-color: #ff3a05;
  }

  .warning5 {
    background-color: #840900;
  }
}
</style>
